/* ==========================================================================
   LILIVIA Maison — theme.js
   Vanilla JS, no dependencies. Every feature is defensive: if the markup
   is not on the page, the feature quietly does nothing.
   ========================================================================== */
(function () {
  'use strict';

  var S = window.themeSettings || {};
  var ROUTES = S.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) { el.addEventListener(ev, fn, opts || false); } }
  function safe(fn) { return function () { try { fn.apply(this, arguments); } catch (err) { if (window.console) { console.warn('[lilivia]', err); } } }; }

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', !!lock);
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = Number(parts[0]).toLocaleString('en-US') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Number(parts[0]).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ------------------------------------------------------- header shadow */
  var header = $('.site-header');
  if (header) {
    var ticking = false;
    var applyHeader = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
      ticking = false;
    };
    on(window, 'scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(applyHeader); }
    }, { passive: true });
    applyHeader();
  }

  /* --------------------------------------------------- scroll progress bar */
  var progressBar = $('[data-scroll-progress]');
  if (progressBar) {
    var updateProgress = function () {
      var doc = document.documentElement;
      var max = (doc.scrollHeight - window.innerHeight);
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      progressBar.style.width = Math.max(0, Math.min(100, pct)) + '%';
    };
    on(window, 'scroll', updateProgress, { passive: true });
    on(window, 'resize', updateProgress);
    updateProgress();
  }

  /* --------------------------------------------------------- back to top */
  var toTop = $('[data-to-top]');
  if (toTop) {
    var toggleTop = function () { toTop.classList.toggle('is-visible', window.scrollY > 600); };
    on(window, 'scroll', toggleTop, { passive: true });
    on(toTop, 'click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    toggleTop();
  }

  /* ------------------------------------------------------ scroll reveal */
  var revealables = $$('.reveal');
  if (revealables.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------ announcement bar */
  $$('[data-announce]').forEach(function (bar) {
    var closeBtn = $('[data-announce-close]', bar);
    var key = 'lilivia-announce-' + (bar.getAttribute('data-announce-id') || 'default');
    try { if (window.sessionStorage.getItem(key) === 'closed') { bar.style.display = 'none'; } } catch (e) {}
    on(closeBtn, 'click', function () {
      bar.style.display = 'none';
      try { window.sessionStorage.setItem(key, 'closed'); } catch (e) {}
    });
    var dur = bar.getAttribute('data-speed');
    var track = $('.announce__track', bar);
    if (track && dur) { track.style.animationDuration = dur + 's'; }
  });

  /* ------------------------------------------- announcement fade rotation */
  $$('[data-announce-fade]').forEach(function (bar) {
    var items = $$('.announce__fade-item', bar);
    if (items.length < 2 || reduceMotion) { return; }
    var i = 0;
    var interval = parseInt(bar.getAttribute('data-interval') || '5', 10) * 1000;
    var paused = false;
    window.setInterval(function () {
      if (paused) { return; }
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
    on(bar, 'mouseenter', function () { paused = true; });
    on(bar, 'mouseleave', function () { paused = false; });
    on(bar, 'focusin', function () { paused = true; });
    on(bar, 'focusout', function () { paused = false; });
  });
  /* ---------------------------------------------------------- marquee band */
  $$('[data-marquee-band]').forEach(function (band) {
    var dur = band.getAttribute('data-speed');
    var track = $('.marquee-band__track', band);
    if (track && dur) { track.style.animationDuration = dur + 's'; }
  });

  /* ------------------------------------------------------- signup popup */
  var nlPopup = $('[data-nl-popup]');
  if (nlPopup) {
    var nlKey = 'lilivia-signup-popup';
    var cooldownDays = parseInt(nlPopup.getAttribute('data-cooldown-days') || '14', 10);
    var lastSeen = null;
    try { lastSeen = window.localStorage.getItem(nlKey); } catch (e) {}
    var cooling = lastSeen && (Date.now() - parseInt(lastSeen, 10)) < cooldownDays * 86400000;
    if (cooling) {
      nlPopup.parentNode.removeChild(nlPopup);
    } else {
      var nlShown = false;
      var nlOpen = function () {
        if (nlShown || !document.body.contains(nlPopup)) { return; }
        nlShown = true;
        nlPopup.hidden = false;
        window.requestAnimationFrame(function () { nlPopup.classList.add('is-open'); });
        lockScroll(true);
        var field = nlPopup.querySelector('input[type="email"]');
        if (field) { window.setTimeout(function () { field.focus({ preventScroll: true }); }, 90); }
      };
      var nlClose = function (remember) {
        nlPopup.classList.remove('is-open');
        window.setTimeout(function () { nlPopup.hidden = true; }, 320);
        lockScroll(false);
        if (remember !== false) { try { window.localStorage.setItem(nlKey, String(Date.now())); } catch (e) {} }
      };
      window.setTimeout(nlOpen, parseInt(nlPopup.getAttribute('data-delay') || '7', 10) * 1000);
      var nlScrollPct = parseInt(nlPopup.getAttribute('data-scroll') || '30', 10);
      on(window, 'scroll', function () {
        if (nlShown) { return; }
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY / max) * 100 >= nlScrollPct) { nlOpen(); }
      }, { passive: true });
      $$('[data-nl-close]', nlPopup).forEach(function (btn) { on(btn, 'click', function () { nlClose(true); }); });
      on(document, 'keydown', function (ev) { if (ev.key === 'Escape' && !nlPopup.hidden) { nlClose(true); } });
      if (nlPopup.querySelector('.form-success')) { try { window.localStorage.setItem(nlKey, String(Date.now())); } catch (e) {} }
    }
  }
  /* ---------------------------------------------------------- hero slider */
  $$('[data-hero]').forEach(safe(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 1) { return; }
    var dots = $$('[data-hero-dot]', hero);
    var progress = $('[data-hero-progress]', hero);
    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) { index = 0; }
    var autoplay = hero.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduceMotion;
    var interval = parseInt(hero.getAttribute('data-interval') || '6500', 10);
    var timer = null, startTime = 0, rafId = null, paused = false;

    function render() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        if (i === index) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (progress) {
        progress.style.transition = 'none';
        progress.style.width = '0%';
        void progress.offsetWidth;
        if (autoplay && !paused) {
          progress.style.transition = 'width ' + interval + 'ms linear';
          progress.style.width = '100%';
        }
      }
    }

    /* One slide at a time: fade the current slide out, then bring the next one in.
       Prevents two slides' text overlapping mid-transition. */
    function go(next) {
      if (slides.length < 2) { return; }
      var target = (next + slides.length) % slides.length;
      if (target === index) { return; }
      window.clearTimeout(timer);
      if (slides[index]) { slides[index].classList.remove('is-active'); }
      window.setTimeout(function () {
        index = target;
        render();
        restart();
      }, reduceMotion ? 0 : 260);
    }

    function tick() {
      if (!autoplay || paused || slides.length < 2) { return; }
      timer = window.setTimeout(function () { go(index + 1); }, interval);
    }

    function restart() { window.clearTimeout(timer); tick(); }

    on($('[data-hero-next]', hero), 'click', function () { go(index + 1); });
    on($('[data-hero-prev]', hero), 'click', function () { go(index - 1); });
    dots.forEach(function (dot, i) { on(dot, 'click', function () { go(i); }); });

    on(hero, 'mouseenter', function () { paused = true; window.clearTimeout(timer); });
    on(hero, 'mouseleave', function () { paused = false; if (autoplay) { render(); restart(); } });
    on(document, 'visibilitychange', function () {
      if (document.hidden) { window.clearTimeout(timer); } else if (autoplay) { restart(); }
    });
    on(hero, 'keydown', function (ev) {
      if (ev.key === 'ArrowRight') { go(index + 1); }
      if (ev.key === 'ArrowLeft') { go(index - 1); }
    });

    /* swipe */
    var startX = 0, startY = 0, moved = false;
    on(hero, 'touchstart', function (ev) {
      if (!ev.touches || ev.touches.length !== 1) { return; }
      startX = ev.touches[0].clientX; startY = ev.touches[0].clientY; moved = true;
    }, { passive: true });
    on(hero, 'touchend', function (ev) {
      if (!moved || !ev.changedTouches || !ev.changedTouches.length) { return; }
      moved = false;
      var dx = ev.changedTouches[0].clientX - startX;
      var dy = ev.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy)) { go(index + (dx < 0 ? 1 : -1)); }
    });

    render();
    if (autoplay) { restart(); }
  }));
  /* --------------------------------------------------------------- drawers */
  var overlay = $('[data-overlay]');
  var openDrawer = null;

  function showOverlay(show) {
    if (!overlay) { return; }
    overlay.hidden = !show;
    window.requestAnimationFrame(function () { overlay.classList.toggle('is-open', show); });
  }
  function openPanel(drawer) {
    if (!drawer) { return; }
    closePanel();
    drawer.hidden = false;
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    lockScroll(true);
    showOverlay(true);
    openDrawer = drawer;
    var focusTarget = drawer.querySelector('[data-drawer-close], button, a[href]');
    if (focusTarget) { window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60); }
  }
  function closePanel() {
    if (!openDrawer) { showOverlay(false); lockScroll(false); return; }
    var drawer = openDrawer;
    drawer.classList.remove('is-open');
    window.setTimeout(function () { drawer.hidden = true; }, 420);
    openDrawer = null;
    lockScroll(false);
    showOverlay(false);
  }
  on(overlay, 'click', function () { closePanel(); });
  on(document, 'keydown', function (ev) { if (ev.key === 'Escape') { closePanel(); } });
  $$('[data-nav-open]').forEach(function (b) { on(b, 'click', function () { openPanel($('[data-nav-drawer]')); }); });
  $$('[data-nav-close]').forEach(function (b) { on(b, 'click', closePanel); });
  $$('[data-cart-open]').forEach(function (b) {
    on(b, 'click', function (ev) {
      if (S.cartType !== 'drawer' || !$('[data-cart-drawer]')) { return; } /* let it navigate to /cart */
      ev.preventDefault();
      openPanel($('[data-cart-drawer]'));
    });
  });
  $$('[data-cart-close]').forEach(function (b) { on(b, 'click', closePanel); });

  /* focus trap while a drawer is open */
  on(document, 'keydown', function (ev) {
    if (ev.key !== 'Tab' || !openDrawer) { return; }
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea', openDrawer).filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) { return; }
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------------ cart */
  var cartState = null;

  function cartCountBubbles(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function lineHTML(item) {
    var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_240x$1$2') : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
    return '' +
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<a class="cart-line__media" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" width="92" height="92" loading="lazy">' : '') + '</a>' +
        '<div class="cart-line__info">' +
          '<h3 class="cart-line__title"><a href="' + item.url + '">' + item.product_title + '</a></h3>' +
          variant +
          '<div class="quantity" data-line-qty>' +
            '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-line-qty-input aria-label="Quantity">' +
            '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__price">' +
          '<div>' + formatMoney(item.final_line_price, S.moneyFormat) + '</div>' +
          '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    cartState = cart;
    cartCountBubbles(cart.item_count);
    var body = $('[data-cart-body]');
    var drawer = $('[data-cart-drawer]');
    if (drawer) { drawer.classList.toggle('is-empty', cart.item_count === 0); }
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="empty-state"><p>Your cart is empty.</p><a class="btn" href="' + (window.Shopify && Shopify.routes ? Shopify.routes.all_products_collection_url : '/collections/all') + '">Continue shopping</a></div>';
      } else {
        body.innerHTML = cart.items.map(lineHTML).join('');
      }
    }
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price, S.moneyFormat); });
    $$('[data-cart-item-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var threshold = parseInt(S.freeShipping || '0', 10);
    if (threshold > 0) {
      var remaining = Math.max(0, threshold * 100 - cart.total_price);
      $$('[data-free-ship-text]').forEach(function (el) {
        el.textContent = remaining > 0
          ? 'Add ' + formatMoney(remaining, S.moneyFormat) + ' more for free U.S. shipping.'
          : 'You have unlocked free U.S. shipping.';
      });
      $$('[data-free-ship-fill]').forEach(function (el) {
        el.style.width = Math.min(100, (cart.total_price / (threshold * 100)) * 100) + '%';
      });
    }
    $$('[data-cart-page]').forEach(function (el) {
      el.innerHTML = cart.item_count === 0
        ? '<div class="empty-state"><h2>Your cart is empty</h2><p>Start with our best-selling silhouettes.</p><a class="btn" href="/collections/all">Shop all bags</a></div>'
        : cart.items.map(lineHTML).join('');
    });
  }

  function getCart() {
    return fetch(ROUTES.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(ROUTES.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(formData) {
    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    }).then(function () { return getCart(); });
  }

  /* cart drawer / page interactions (event delegation) */
  on(document, 'click', function (ev) {
    var qtyBtn = ev.target.closest('[data-qty-change]');
    if (qtyBtn) {
      ev.preventDefault();
      var wrap = qtyBtn.closest('.quantity');
      var input = wrap ? wrap.querySelector('input') : null;
      if (input) {
        var step = parseInt(qtyBtn.getAttribute('data-qty-change'), 10) || 0;
        var minQty = parseInt(input.getAttribute('min') || '0', 10);
        var next = Math.max(minQty, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        var line = qtyBtn.closest('[data-line-key]');
        if (line) { changeLine(line.getAttribute('data-line-key'), next); }
      }
      return;
    }
    var removeBtn = ev.target.closest('[data-line-remove]');
    if (removeBtn) {
      ev.preventDefault();
      var lineEl = removeBtn.closest('[data-line-key]');
      if (lineEl) { changeLine(lineEl.getAttribute('data-line-key'), 0); }
      return;
    }
    var submitCart = ev.target.closest('[data-cart-page-submit]');
    if (submitCart) {
      var cartForm = submitCart.closest('form');
      if (cartForm) { cartForm.submit(); }
    }
  });


  /* add to cart: product forms + quick add */
  $$('form[data-product-form], form[data-quick-add], [data-product-root] form[action*="/cart/add"]').forEach(function (form) {
    on(form, 'submit', function (ev) {
      if (!window.fetch) { return; } /* progressive enhancement: normal POST */
      ev.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = 'Adding…'; btn.classList.add('is-disabled'); }
      addToCart(new FormData(form)).then(function () {
        if (btn) { btn.innerHTML = original; btn.classList.remove('is-disabled'); }
        var openBtn = $('[data-cart-open]');
        if (S.cartType === 'drawer' && $('[data-cart-drawer]')) { openPanel($('[data-cart-drawer]')); }
        else if (openBtn) { window.location.href = ROUTES.cart; }
      }).catch(function (err) {
        if (btn) { btn.innerHTML = original; btn.classList.remove('is-disabled'); }
        var msg = (err && err.description) ? err.description : 'Sorry, this item could not be added. Please try again.';
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = msg; note.hidden = false; } else { window.alert(msg); }
      });
    });
  });
  /* ------------------------------------------------------------ header search */
  $$('[data-search-toggle]').forEach(function (btn) {
    on(btn, 'click', function (ev) {
      ev.preventDefault();
      var panel = $('[data-header-search]');
      if (!panel) { return; }
      var isOpen = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) { var input = panel.querySelector('input[type="search"]'); if (input) { input.focus(); } }
    });
  });
  on(document, 'keydown', function (ev) {
    if (ev.key !== 'Escape') { return; }
    var open = $('[data-header-search].is-open');
    if (open) { open.classList.remove('is-open'); }
  });

  /* ---------------------------------------------------- product gallery */
  $$('[data-gallery]').forEach(safe(function (gallery) {
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!slides.length) { return; }
    function select(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
        t.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function (ev) { ev.preventDefault(); select(i); });
    });
    /* keyboard + swipe */
    var startX = 0;
    on(gallery, 'touchstart', function (ev) { if (ev.touches && ev.touches.length === 1) { startX = ev.touches[0].clientX; } }, { passive: true });
    on(gallery, 'touchend', function (ev) {
      if (!ev.changedTouches || !ev.changedTouches.length) { return; }
      var dx = ev.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 46) { return; }
      var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      select((current + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
    });

    /* click to zoom */
    var dialog = $('[data-zoom-dialog]');
    if (dialog) {
      var zoomImg = $('[data-zoom-image]', dialog);
      $$('[data-zoom-open]', gallery).forEach(function (btn) {
        on(btn, 'click', function (ev) {
          ev.preventDefault();
          var idx = parseInt(btn.getAttribute('data-zoom-open'), 10) || 0;
          var src = btn.getAttribute('data-zoom-src') || (slides[idx] ? slides[idx].getAttribute('data-image-src') : '');
          if (src && zoomImg) { zoomImg.src = src; }
          dialog.hidden = false;
          lockScroll(true);
          var close = $('[data-zoom-close]', dialog);
          if (close) { close.focus(); }
        });
      });
      var closeDialog = function () {
        dialog.hidden = true;
        lockScroll(false);
        if (openDrawer) { lockScroll(true); }
      };
      on($('[data-zoom-close]', dialog), 'click', closeDialog);
      on(dialog, 'click', function (ev) { if (ev.target === dialog) { closeDialog(); } });
      on(document, 'keydown', function (ev) { if (ev.key === 'Escape' && !dialog.hidden) { closeDialog(); } });
    }
  }));

  /* ------------------------------------------------- variants + sticky bar */
  $$('[data-product-root]').forEach(safe(function (root) {
    var variantsEl = $('[data-variants-json]', root) || $('[data-variants-json]');
    var form = $('form[data-product-form]', root);
    if (!form) { return; }
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }

    function currentOptions() {
      var selects = $$('[data-option-select], fieldset', form);
      var chosen = [];
      $$('[data-option-index]', form).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        chosen[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return chosen;
    }

    function updateProduct() {
      if (!variants.length) { return; }
      var chosen = currentOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return chosen[i] === undefined || chosen[i] === null || String(opt) === String(chosen[i]); });
      })[0];
      if (!match) { return; }
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) { idInput.value = match.id; }
      var price = $('[data-price]', root);
      if (price) {
        price.innerHTML = match.compare_at_price > match.price
          ? '<span class="is-sale">' + match.price_formatted + '</span> <s>' + match.compare_at_price_formatted + '</s>'
          : match.price_formatted;
      }
      var btn = form.querySelector('[data-add-button]');
      if (btn) {
        btn.disabled = !match.available;
        btn.innerHTML = match.available ? (btn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      var stickyBtn = $('[data-sticky-atc] [data-add-button]');
      if (stickyBtn) {
        stickyBtn.disabled = !match.available;
        stickyBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      try {
        var url = new URL(window.location.href);
        if (match.id) { url.searchParams.set('variant', match.id); }
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    $$('[data-option-index]', form).forEach(function (group) {
      $$('input, select', group).forEach(function (input) {
        on(input, 'change', function () {
          $$('label', group).forEach(function (label) { label.classList.toggle('is-selected', !!label.querySelector('input:checked')); });
          $$('select', group).forEach(function (sel) { var lbl = sel.closest('.pdp__option'); if (lbl) { lbl.classList.add('is-selected'); } });
          updateProduct();
        });
      });
    });

    /* sticky bar visibility driven by the main buy button */
    var sticky = $('[data-sticky-atc]');
    var anchor = $('[data-buy-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      sio.observe(anchor);
    }
    updateProduct();
  }));

  /* ----------------------------------------- collection sort fallback (once) */
  $$('[data-sort-fallback]').forEach(function (sel) {
    var target = sel.getAttribute('data-sort-fallback');
    if (target && window.history && window.history.replaceState) {
      window.location.replace(target);
    }
  });
  /* ------------------------------------------- filters & sort auto-submit */
  $$('[data-facets] input[type="checkbox"], [data-facets] input[type="radio"]').forEach(function (input) {
    on(input, 'change', function () { if (input.form) { input.form.submit(); } });
  });
  $$('[data-sort-select]').forEach(function (sel) {
    on(sel, 'change', function () { if (sel.form) { sel.form.submit(); } });
  });
  /* --------------------------------------------------- initial cart state */
  if (document.body.classList.contains('template-cart') || $('[data-cart-count]') || $('[data-cart-body]')) {
    getCart().catch(function () { /* offline or blocked: server-rendered markup stays */ });
  }
})();